import { useState, useEffect, useCallback } from 'react';
import { adminMessagesApi, adminVerificationsApi, adminUsersApi, adminReportsApi } from '../store/api/adminApi';

interface ModerationStats {
  pendingMessages: number;
  pendingVerifications: number;
  deletionRequests: number;
  pendingReports: number;
}

const POLL_INTERVAL = 60_000;

export function useModerationStats(enabled = true) {
  const [stats, setStats] = useState<ModerationStats>({ pendingMessages: 0, pendingVerifications: 0, deletionRequests: 0, pendingReports: 0 });

  const fetch = useCallback(async () => {
    const [msgResult, verResult, delResult, rptResult] = await Promise.allSettled([
      adminMessagesApi.getModerationQueue({ limit: 1 }),
      adminVerificationsApi.list({ status: 'PENDING', limit: 1 }),
      adminUsersApi.list({ status: 'DELETION_REQUESTED', limit: 1 }),
      adminReportsApi.stats(),
    ]);
    setStats((prev) => ({
      pendingMessages: msgResult.status === 'fulfilled' ? (msgResult.value.data?.total ?? 0) : prev.pendingMessages,
      pendingVerifications: verResult.status === 'fulfilled' ? (verResult.value.data?.total ?? 0) : prev.pendingVerifications,
      deletionRequests: delResult.status === 'fulfilled' ? (delResult.value.data?.total ?? 0) : prev.deletionRequests,
      pendingReports: rptResult.status === 'fulfilled' ? (rptResult.value.data?.pending ?? 0) : prev.pendingReports,
    }));
  }, []);

  useEffect(() => {
    if (!enabled) return;
    fetch();
    const id = setInterval(fetch, POLL_INTERVAL);
    return () => clearInterval(id);
  }, [fetch, enabled]);

  return stats;
}
